import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Casino = () => {
    const styles = {
        ar_game_corner_section: {
            padding: '50px 0',
            color: 'white'
        },
        ar_game_card: {
            background: 'linear-gradient(135deg, rgba(40, 40, 40, 0.9), rgba(20, 20, 20, 0.95))',
            border: '2px solid #ff0055',
            borderRadius: '15px',
            padding: '20px',
            marginBottom: '30px',
            textAlign: 'center',
            transition: 'transform 0.3s, box-shadow 0.3s',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        ar_game_icon: {
            fontSize: '50px',
            color: '#ff0055',
            marginBottom: '20px'
        },
        ar_game_title: {
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '10px',
            color: '#fff'
        },
        ar_game_desc: {
            color: '#ccc',
            fontSize: '14px',
            marginBottom: '20px'
        },
        ar_play_btn: {
            background: 'linear-gradient(to right, #ff0055, #ff5500)',
            border: 'none',
            color: 'white',
            padding: '10px 30px',
            borderRadius: '25px',
            fontWeight: 'bold',
            width: '100%',
            textTransform: 'uppercase'
        },
        ar_jackpot: {
            background: 'rgba(255, 215, 0, 0.1)',
            border: '1px dashed #ffd700',
            padding: '10px',
            borderRadius: '5px',
            marginBottom: '15px',
            color: '#ffd700'
        }
    };

    return (
        <div className="ar_mainBody">
            <section className="ar_main_content_area_wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ar_main_container_area">
                                <div className="ar_heading_area_top">
                                    <div className="ar_heading_title_back">
                                        <Link className="ar_back" to="/city"><img src="/assets/images/game-ui/reButton.png" alt="back" /></Link>
                                        <h3>קזינו</h3>
                                        <Link to="#"><img src="/assets/images/game-ui/question.png" alt="help" /></Link>
                                    </div>
                                    <div className="ar_heading_title_plus">
                                        <div className="arTitle_plus_area">
                                            <div className="arTitle_plus_img">
                                                <img src="/assets/images/game-ui/p1.png" alt="" />
                                                <p>198923</p>
                                            </div>
                                            <div className="arTitle_plus_img">
                                                <img src="/assets/images/game-ui/p2.png" alt="" />
                                                <p className="one152">152</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section style={styles.ar_game_corner_section}>
                <div className="container">
                    <div className="row">
                        
                        {/* Game 1: Slots */}
                        <div className="col-md-4 col-sm-6">
                            <div style={styles.ar_game_card}>
                                <div>
                                    <div style={styles.ar_game_icon}><i className="fa fa-gem"></i></div>
                                    <h4 style={styles.ar_game_title}>מכונת המזל</h4>
                                    <p style={styles.ar_game_desc}>סובב את הגלגלים ונסה להשיג 3 שביעיות! הפרס הגדול מחכה.</p>
                                    <div style={styles.ar_jackpot}>הפרס הגדול: 50,000 זהב</div>
                                </div>
                                <button style={styles.ar_play_btn}>שחק עכשיו</button>
                            </div>
                        </div>

                        {/* Game 2: Roulette */}
                        <div className="col-md-4 col-sm-6">
                            <div style={styles.ar_game_card}>
                                <div>
                                    <div style={styles.ar_game_icon}><i className="fa fa-dot-circle"></i></div>
                                    <h4 style={styles.ar_game_title}>רולטה פוקימון</h4>
                                    <p style={styles.ar_game_desc}>המר על הצבע או הסוג (אש, מים, דשא) וזכה בכפול מהכסף!</p>
                                    <div style={styles.ar_jackpot}>מכפיל עד x36</div>
                                </div>
                                <button style={styles.ar_play_btn}>שחק עכשיו</button>
                            </div>
                        </div>

                        {/* Game 3: Cards */}
                        <div className="col-md-4 col-sm-6">
                            <div style={styles.ar_game_card}>
                                <div>
                                    <div style={styles.ar_game_icon}><i className="fa fa-heart"></i></div> {/* changed to heart for cards */}
                                    <h4 style={styles.ar_game_title}>פוקר מאמנים</h4>
                                    <p style={styles.ar_game_desc}>שחק קלפים נגד מאמנים אחרים. המנצח לוקח את כל הקופה.</p>
                                    <div style={styles.ar_jackpot}>טורניר יומי פעיל</div>
                                </div>
                                <button style={styles.ar_play_btn}>שחק עכשיו</button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default Casino;
